import { render, staticRenderFns } from "./TaskTeamSelector.vue?vue&type=template&id=072e35bc&"
import script from "./TaskTeamSelector.vue?vue&type=script&lang=js&"
export * from "./TaskTeamSelector.vue?vue&type=script&lang=js&"
import style0 from "./TaskTeamSelector.vue?vue&type=style&index=0&id=072e35bc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports